import React from "react";
   import { Link, useLocation } from "react-router-dom";
   import '../css/HorizontalNavbar.css'; // Add this line for styling

   const HorizontalNavbar = () => {
     const location = useLocation(); // Get the current route
     const isLoginPage = location.pathname === '/login'; // Check if the current route is '/login'

     return (
       <nav className="horizontal-navbar">
         <ul className="nav-links">
           <li><Link to="/">Home</Link></li>
           {!isLoginPage && (
             <>
               <li className="dropdown">
                 <Link to="/AboutUs" className="dropbtn">About Us</Link>
                 
               </li>
               <li className="dropdown">
                 <Link to="/Services" className="dropbtn">Services</Link>
                 
               </li>
               <li className="dropdown">
                 <Link to="/Features" className="dropbtn">Features</Link>
                
               </li>
               <li className="dropdown">
                 <Link to="/Pricing" className="dropbtn">Pricing</Link>
                
               </li>
               <li className="dropdown">
                 <Link to="/contact-us" className="dropbtn">ContactUs</Link>
                
               </li>
             </>
           )}
         </ul>
       </nav>
     );
   };

   export default HorizontalNavbar;